import React from 'react'
interface StatusPostDeliveryIconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
}

export function StatusPostDeliveryIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
}: StatusPostDeliveryIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Outer circle */}
      <circle cx="12" cy="12" r="10" />
      {/* Hand/thumbs up for satisfaction */}
      <path d="M9 15v-4c0-1 0.5-2 1-2s1 1 1 2v4" />
      <path d="M11 13v2" />
      <path d="M13 15v-2c0-1 0.5-1.5 1-1.5s1 0.5 1 1.5v2" />
      {/* Smile */}
      <path d="M10 11h4" />
    </svg>
  )
}
